﻿import {IProgress, translation} from "@2d-front-monorepo/core";
import {toggleLoadingDialog} from "@2d-front-monorepo/design-library";

export function useProgressReport(progress: IProgress): void {
	toggleLoadingDialog(true, {
		label: progress.label && translation(progress.label, progress),
		total: progress.total,
		current: progress.current
	});
}
